import { useTranslation } from "react-i18next";

const AgentRoleOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "AGENT",
      title: t("options.agentrole.agent"),
      value: "AGENT",
    },
    {
      key: "SUPER",
      title: t("options.agentrole.super"),
      value: "SUPER",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default AgentRoleOptions;
